import { CommonModule, NgFor, NgIf } from '@angular/common'
import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { KENDO_BUTTON, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_INDICATORS, KENDO_LOADER } from '@progress/kendo-angular-indicators'
import { IntlService } from '@progress/kendo-angular-intl'
import * as CryptoJS from 'crypto-js'
import { ToastrService } from 'ngx-toastr'
import { environment } from '../../../../environments/environment'
import { TransactionsServices } from '../../../@theme/services/transactions.service'
import { RvFieldBuilderComponent } from '../Rvfieldbuilder/rvfield-builder.component'
@Component({
  selector: 'gd-rvstep2form',
  styleUrls: ['./RVstep2Transactions.component.css'],
  template: `
    <form
      (ngSubmit)="submitEvent.emit(this.form.value)"
      [formGroup]="form"
      class="form-horizontal"
    >
      <div *ngFor="let field of fields">
        <gd-rvfield-builder
          [field]="field"
          [form]="form"
          [clientId]="clientId"
          *ngIf="field.label !== null"
        ></gd-rvfield-builder>
      </div>
      <div
        class="form-group row"
        style="float:right;margin-top:-100px; margin-right:250px;"
      >
        <div class="col-md-12" style="margin-top: 50px;">
        <button
  kendoButton
  type="submit"
  [disabled]="!form.valid || loading"
  class="px-5 py-3 text-sm font-medium rounded-md
         border border-blue-600 text-blue-600
         hover:bg-blue-50 dark:hover:bg-blue-900
         focus:outline-none focus:ring-2 focus:ring-blue-300
         disabled:opacity-50 disabled:cursor-not-allowed
         flex items-center gap-2 transition-colors duration-200"
>
  <ng-container *ngIf="loading; else label">
    <span class="k-icon k-i-loading animate-spin"></span>
    <span>Saving...</span>
  </ng-container>
  <ng-template #label>Save</ng-template>
</button>
        </div>
      </div>
    </form>
  `,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    NgIf,
    RvFieldBuilderComponent,
    KENDO_BUTTON,
    KENDO_LOADER,
    KENDO_INDICATORS,
    KENDO_BUTTONS
  ]
}) //  || !roletype
export class RVStep2TransactionFormComponent implements AfterContentInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loader: any
  @Output() submitEvent = new EventEmitter()
  @Output() stopLoader = new EventEmitter()
  unsubcribe: any
  @Input() RepSelected: number
  @Input() loading: boolean
  @Input() ClientSelected: number
  @Input() productTypeSelected: number
  @Input() transactionTypeSelected: number
  @Input() SourceofFundsSelected: number
  @Input() RepCodeSelected: number
  @Input() repNamestring: string
  @Input() repCodestring: string
  @Input() Clientstring: string
  @Input() productTypestring: string
  @Input() transactionTypestring: string
  @Input() sourceoffundsstring: string
  @Input() clientthirdlisting: Array<any>
  @Input() taxen: string
  public clientlist: any[] = []
  public fields: any[] = []
  public value: Date = new Date()
  @Input() LiquidNWTo: string
  @Input() LiquidNWFrom: string
  @Input() NetWorthTo: string
  @Input() NetWorthFrom: string
  @Input() AnnualIncTo: string
  @Input() AnnualIncFrom: string
  private index = 0
  private getname: string
  @Input() InvestmentProfileId: number
  @Input() InvestmentTimeHorizonId: number
  @Input() LiquidityNeedsId: number
  @Input() InvObjectiveId: number
  public roletype: boolean
  @Input() InvestDescription: string
  @Input() InvestmentTimeHorizonDescription: string
  @Input() ProfileDescription: string
  @Input() LiquidDescription: string

  @Input() clientId: number
  @Input() lblRep: string
  @Input() dob: Date
  @Input() Email: string
  public blotId: number
  public sendblot: any
  public form: UntypedFormGroup
  public paramsVal: any
  constructor(
    private toastrService: ToastrService,
    private transservice: TransactionsServices,
    private route: ActivatedRoute,
    private Intl: IntlService,
  ) {
    this.form = new UntypedFormGroup({
      fields: new UntypedFormControl({ value: this.fields, disabled: true }),
    })
  }
  ngAfterContentInit(): void {
    setTimeout(() => {
      this.loader = {
        hasProgressBar: true,
        loaderId: 'customLoaderId',
        isMaster: false,
        fgsSize: 100,
        bgsSize: 64,
        gap: 80,
        text: 'Custom Spinner',
      }
      if (this.route.snapshot.queryParams['Rview']) {
        this.route.queryParams.subscribe((params) => {
          const getblotterClientId = CryptoJS.AES.decrypt(
            params['Rview'],
            `${environment.securepw}`,
          ).toString(CryptoJS.enc.Utf8)
          this.blotId = Number(getblotterClientId)
          this.sendblot = { blotterId: this.blotId }
        })
      }
      const storageValue =
        localStorage.getItem('rrolelisted') == undefined
          ? ''
          : localStorage.getItem('rrolelisted')
      const paramTR = CryptoJS.AES.decrypt(
        storageValue,
        environment.securepw,
      ).toString(CryptoJS.enc.Utf8)
      this.paramsVal = {
        blotterId: this.blotId,
        role: paramTR,
      }
      this.loadform(this.paramsVal)
    }, 3000)
  }

  loadform(paramsVal) {
    if (paramsVal !== undefined) {
      const data = this.transservice
        .GetReviewquestions(paramsVal)
        .subscribe((response: UntypedFormGroup[]) => {
          this.fields = response
          this.form = new UntypedFormGroup({
            fields: new UntypedFormControl({
              value: this.fields,
              disabled: true,
            }),
          })
          const fieldsCtrls = {}
          for (const f of this.fields) {
            if (f.required === true) {
              fieldsCtrls[f.name] = new UntypedFormControl({
                value: f.value,
                disabled: true,
              })
            } else {
              fieldsCtrls[f.name] = new UntypedFormControl({
                value: f.value,
                disabled: false,
              })
            }
          }
          this.form = new UntypedFormGroup(fieldsCtrls)
          this.stopLoader.emit(false)
        })
      return data
    }
    return null
  }
  public findInvalidControls() {
    const invalid = []
    const controls = this.form.controls
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name)
        this.getname = name
        this.showToast(0)
      }
    }
    return invalid
  }
  showToast(duration) {
    this.toastrService.show(this.getname, `You are missing a value :`)
  }
}
